"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactMethods = [{
  label: "INQUIRIES",
  value: "LuxuryConstructionInvestments@gmail.com",
  href: "mailto:LuxuryConstructionInvestments@gmail.com"
}, {
  label: "SUPPORT",
  value: "LuxuryConstructionInvestments@gmail.com",
  href: "mailto:LuxuryConstructionInvestments@gmail.com"
}, {
  label: "PARTNERSHIPS",
  value: "LuxuryConstructionInvestments@gmail.com",
  href: "mailto:LuxuryConstructionInvestments@gmail.com"
}, {
  label: "DIRECT",
  value: "(620) 640-0354",
  href: "tel:+16206400354"
}];
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-10 border border-border bg-card shadow-md">
        <p className="font-default text-2xl text-foreground mb-6">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="border-primary text-foreground hover:bg-primary hover:text-primary-foreground">
          Send another message
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-10">
        <FormField control={control} name="name" render={({
        field
      }) => <FormItem data-index={0} className="grid gap-2">
              <FormControl>
                <Input {...field} placeholder="John Doe" className="h-12 px-0 bg-transparent border-0 border-b border-border text-foreground placeholder:text-muted-foreground focus-visible:ring-0 focus-visible:border-primary focus-visible:border-b-2 transition-colors" />
              </FormControl>
              <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                Your Name *
              </FormLabel>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" render={({
        field
      }) => <FormItem data-index={1} className="grid gap-2">
              <FormControl>
                <Input {...field} type="email" placeholder="john@example.com" className="h-12 px-0 bg-transparent border-0 border-b border-border text-foreground placeholder:text-muted-foreground focus-visible:ring-0 focus-visible:border-primary focus-visible:border-b-2 transition-colors" />
              </FormControl>
              <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                Email Address *
              </FormLabel>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem className="grid gap-2">
            <FormControl>
              <Input {...field} type="tel" placeholder="(620) 640-0354" className="h-12 px-0 bg-transparent border-0 border-b border-border text-foreground placeholder:text-muted-foreground focus-visible:ring-0 focus-visible:border-primary focus-visible:border-b-2 transition-colors" />
            </FormControl>
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              Phone Number *
            </FormLabel>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="preferred_time" render={({
      field
    }) => <FormItem className="grid gap-2">
            <FormControl>
              <Select onValueChange={field.onChange} value={field.value}>
                <SelectTrigger className="h-12 w-full px-0 bg-transparent border-0 border-b border-border text-foreground data-[placeholder]:text-muted-foreground focus-visible:ring-0 focus-visible:border-primary">
                  <SelectValue placeholder="Select a time" />
                </SelectTrigger>
                <SelectContent className="bg-card border-border">
                  <SelectItem value="Morning (8 am - 12 pm)" className="font-mono text-xs uppercase tracking-wider">Morning (8 am - 12 pm)</SelectItem>
                  <SelectItem value="Afternoon (12 pm - 5 pm)" className="font-mono text-xs uppercase tracking-wider">Afternoon (12 pm - 5 pm)</SelectItem>
                  <SelectItem value="Evening (5 pm - 9 pm)" className="font-mono text-xs uppercase tracking-wider">Evening (5 pm - 9 pm)</SelectItem>
                </SelectContent>
              </Select>
            </FormControl>
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              Preferred Contact Time
            </FormLabel>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" render={({
      field
    }) => <FormItem className="grid gap-2">
            <FormControl>
              <Textarea {...field} placeholder="Tell us about your project or property..." className="min-h-[180px] px-0 py-3 bg-transparent border-0 border-b border-border text-foreground placeholder:text-muted-foreground focus-visible:ring-0 focus-visible:border-primary focus-visible:border-b-2 transition-colors resize-none" />
            </FormControl>
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              Project Details
            </FormLabel>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 border border-destructive bg-destructive/10">
          <p className="font-mono text-xs uppercase tracking-wider text-destructive">{submitError}</p>
        </div>}

      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pt-4">
        <FormField control={control} name="consent" render={({
        field
      }) => <FormItem className="flex flex-row items-center gap-3 space-y-0">
              <FormControl>
                <Checkbox checked={field.value} onCheckedChange={field.onChange} className="border-border data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=checked]:text-primary-foreground" />
              </FormControl>
              <FormLabel className="font-default text-sm text-foreground/70 cursor-pointer">
                I agree to the privacy policy
              </FormLabel>
            </FormItem>} />

        <Button type="submit" disabled={isSubmitting} className="h-12 px-8 bg-primary text-primary-foreground hover:bg-primary/90 font-default font-bold text-xs uppercase tracking-[0.25em] shadow-md">
          {isSubmitting ? "Sending..." : "Submit Request"}
          <ArrowRight className="size-4 ml-2" />
        </Button>
      </div>
    </Form>;
}
export default function SendUsAMessage() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2998" id="send-us-a-message" className="bg-background text-foreground relative overflow-hidden pt-32 md:pt-40 pb-24 md:pb-30 px-6 md:px-12 lg:px-20">
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]">
        <div className="absolute top-1/4 -left-40 w-[600px] h-[600px] bg-primary blur-[160px]" />
      </div>

      <div className="relative max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div ref={leftRef} className={`lg:col-span-5 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center gap-3 mb-10">
            <span className="inline-block w-2 h-2 bg-primary" />
            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-primary">
              CONTACT — 01 · GET IN TOUCH
            </span>
          </div>

          <h2 className="font-default font-bold leading-[0.9] tracking-tight text-foreground mb-10">
            <span className="block" style={{
            fontSize: "clamp(3.5rem, 8vw, 7rem)"
          }}>
              Start Your
            </span>
            <span className="block" style={{
            fontSize: "clamp(3.5rem, 8vw, 7rem)"
          }}>
              Project
              <span className="inline-block align-baseline ml-2 w-4 h-4 md:w-6 md:h-6 bg-primary" />
            </span>
          </h2>

          <p className="font-default text-lg leading-relaxed text-foreground/70 max-w-[360px] mb-14">
            Whether you need a roof inspection or a cash offer for your home, our team is ready to assist.
          </p>

          <div className="flex flex-col">
            {contactMethods.map((method, i) => <div data-index={i} key={method.label} className="group flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-2 py-5 border-t border-border last:border-b">
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                  {method.label}
                </span>
                <Link to={method.href} className="font-default text-lg md:text-xl text-foreground border-b border-primary/60 hover:border-primary transition-colors">
                  {method.value}
                </Link>
              </div>)}
          </div>
        </div>

        <div ref={rightRef} className={`lg:col-span-7 transition-all duration-1000 delay-150 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <FormProvider formKey="contact_form_contact_us" formId="contact_form_contact_us" sectionName="send-us-a-message" defaultValues={{
          name: "",
          email: "",
          phone: "",
          preferred_time: "",
          message: "",
          consent: false
        }} validationRules={{
          name: {
            required: true,
            minLength: 2
          },
          email: {
            required: true,
            pattern: "email"
          },
          phone: {
            required: true,
            minLength: 6
          }
        }} submitText="Submit Request" successMessage="Message received. Our team will contact you shortly." errorMessage="Submission failed. Please try again." className="relative">
            <div className="relative bg-card border border-border p-8 md:p-14 shadow-lg">
              <div className="absolute top-6 right-6 md:top-8 md:right-8 flex items-center gap-2">
                <span className="inline-block w-1.5 h-1.5 bg-primary animate-pulse" />
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-primary">
                  FAST RESPONSE
                </span>
              </div>

              <div className="flex items-center gap-3 mb-12">
                <span className="inline-block w-3 h-3 bg-primary" />
                <h3 className="font-default font-bold text-2xl uppercase tracking-tight text-foreground">
                  Send A Message
                </h3>
              </div>

              <ContactForm />
            </div>
          </FormProvider>
        </div>
      </div>
    </section>;
}